import { render, staticRenderFns } from "./px-questionary-currency-range.vue?vue&type=template&id=38627bb2&scoped=true&"
import script from "./px-questionary-currency-range.vue?vue&type=script&lang=ts&"
export * from "./px-questionary-currency-range.vue?vue&type=script&lang=ts&"
import style0 from "./px-questionary-currency-range.vue?vue&type=style&index=0&id=38627bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38627bb2",
  null
  
)

export default component.exports